import { render, staticRenderFns } from "./detail-basic.vue?vue&type=template&id=537d902e&scoped=true"
import script from "./detail-basic.vue?vue&type=script&lang=js"
export * from "./detail-basic.vue?vue&type=script&lang=js"
import style0 from "./detail-basic.vue?vue&type=style&index=0&id=537d902e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d902e",
  null
  
)

export default component.exports